import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('messages');

export class WorkflowAreas extends Api {
  constructor(http, config = {}) {
    super(http, url, 'areas', config);
  }
}